// Shared constants for dashboard/cards (address fallback, demo date, electricity price)
export const BUILDING_ADDRESS = 'Aigeos 56';

// Demo "today" for consistent occupancy logic
export const DEMO_TODAY = '2025-02-25';

// Electricity price change (percent): month-over-month, year-over-year
export const ELECTRICITY_PRICE_CHANGE_MOM = 2.5;
export const ELECTRICITY_PRICE_CHANGE_YOY = -0.8;

const DEFAULT_LAST_DAYS_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const getTotalBuildingConsumption = (list = []) =>
    list.reduce((sum, item) => sum + (Number(item.totalConsumption) || 0), 0);

/**
 * Map API house entity to the shape expected by DashboardApartmentCard / ApartmentCardEnergy.
 * API may return id, address, name, typeHouse, year, area, and optionally consumption/occupancy fields.
 */
export const mapHouseToApartment = (house) => {
    const id = house.id != null ? String(house.id) : '';
    const name = house.name || house.title || house.address || `House ${id}`;
    const totalConsumption = Number(house.totalConsumption) || 0;
    const billingCost = house.billingCost != null ? Number(house.billingCost) : null;
    return {
        id,
        name,
        address: house.address,
        buildingId: house.buildingId != null ? String(house.buildingId) : null,
        buildingName: house.buildingName || '',
        buildingAddress: house.buildingAddress || house.address || '',
        floor: house.floor != null ? String(house.floor) : '',
        totalConsumption,
        billingCost,
        lastDaysConsumption: Array.isArray(house.lastDaysConsumption) && house.lastDaysConsumption.length === 7
            ? house.lastDaysConsumption
            : [0, 0, 0, 0, 0, 0, 0],
        lastDaysLabels: Array.isArray(house.lastDaysLabels) && house.lastDaysLabels.length === 7
            ? house.lastDaysLabels
            : DEFAULT_LAST_DAYS_LABELS,
        checkIn: house.checkIn || null,
        checkOut: house.checkOut || null,
        lastStayCheckIn: house.lastStayCheckIn || null,
        lastStayCheckOut: house.lastStayCheckOut || null,
        nextCheckIn: house.nextCheckIn || null,
        nextCheckOut: house.nextCheckOut || null,
        occupancyRateThisMonth: house.occupancyRateThisMonth != null ? Number(house.occupancyRateThisMonth) : 0,
    };
};
